import PropTypes from 'prop-types';

const BAR_WIDTHS = {
	1: [4],
	2: [3.2, 3.2],
	3: [2.4, 2.4, 2.4],
	4: [1.9, 1.9, 1.9, 1.9],
};

const StatisticsWidthIcon = ({ className, size = 17, colSpan = 1 }) => {
	const bars = BAR_WIDTHS[colSpan] ?? BAR_WIDTHS[1];
	const gap = 1.35;
	const totalWidth = bars.reduce((sum, width) => sum + width, 0) + gap * (bars.length - 1);
	const offsetX = (16 - totalWidth) / 2;

	return (
		<svg
			className={className}
			width={size}
			height={size}
			viewBox='0 0 16 16'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			aria-hidden='true'
		>
			{bars.map((width, index) => {
				const x = offsetX + index * (width + gap);
				return (
					<rect
						key={index}
						x={x}
						y='3.2'
						width={width}
						height='9.6'
						rx='0.9'
						stroke='currentColor'
						strokeWidth='1.2'
						opacity={index === 0 ? 1 : 0.72}
					/>
				);
			})}
		</svg>
	);
};

StatisticsWidthIcon.propTypes = {
	className: PropTypes.string,
	size: PropTypes.number,
	colSpan: PropTypes.oneOf([1, 2, 3, 4]),
};

export default StatisticsWidthIcon;
